import { withNamespaces } from 'react-i18next';
import { Button, Spinner } from 'reactstrap';

import MessageBody from '../../message-detail/components/MessageBody';
import useMailboxAttachments from '../../message-detail/hooks/useMailboxAttachments';
import {
    formatMailboxDate,
    getAttachmentFilename,
    getAttachmentId,
    getMessageDate,
    getMessageFromParty,
    getMessageSubject,
} from '../../../helpers';

const ThreadMessage = ({
    t,
    message,
    embedded = false,
}) => {
    const party = getMessageFromParty(message);
    const {
        regularAttachments,
        rewrittenHtml,
        downloadAttachment,
        downloadingId,
    } = useMailboxAttachments({
        t,
        message,
    });

    return (
        <div className={embedded ? 'overflow-hidden' : 'border rounded p-3 overflow-hidden'}>
            {embedded ? null : (
                <>
                    <div className="d-flex justify-content-between flex-wrap mb-2">
                        <strong>
                            {party.display || party.email || t('Unknown sender')}
                        </strong>
                        <span className="text-muted">
                            {formatMailboxDate(getMessageDate(message))}
                        </span>
                    </div>
                    <div className="mb-2">
                        {getMessageSubject(message) || t('(No subject)')}
                    </div>
                </>
            )}
            <MessageBody
                message={message}
                html={rewrittenHtml}
            />
            {regularAttachments.length ? (
                <div className="mt-3">
                    {regularAttachments.map((attachment) => {
                        const attachmentId = getAttachmentId(attachment);

                        return (
                            <Button
                                key={attachmentId || getAttachmentFilename(attachment)}
                                type="button"
                                color="link"
                                className="p-0 me-3"
                                disabled={Boolean(downloadingId)}
                                onClick={() => downloadAttachment(attachment)}
                            >
                                <i className="mdi mdi-paperclip me-1" />
                                {getAttachmentFilename(attachment)}
                                {downloadingId === attachmentId ? (
                                    <Spinner size="sm" className="ms-1" />
                                ) : null}
                            </Button>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};

export default withNamespaces()(ThreadMessage);
